import backend from '@common/backend';
import { Role } from '@common/components/RBAC';

export interface ICgAdminProfileChats {
	id: string;
	chatJWT: string;
}

const BASE = '/chats';

export const getChats = () => backend.get(BASE);

export const getCgAdminProfileChats = (): Promise<ICgAdminProfileChats> =>
	backend.get(`${BASE}/cgAdminProfile`);

export interface IGetChatUnreadCountTeachers {
	page: number;
	limit: number;
	roles: Role[];
}

export const getChatUnreadCountTeachers = (params: IGetChatUnreadCountTeachers) =>
	backend.get(`${BASE}/unreadMessagesCount`, { params });
